import React__default, { forwardRef } from 'react';
import { AtlasTextfieldWrapper, StyledAtlasTextInput } from './AtlasTextfieldWrapper.js';
import { useRefObjectAsForwardedRef } from '../../hooks/useRefObjectAsForwardedRef.js';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// We pick out TextInputProps that collide with AtlassianTextFieldProps
// as well as any duplicative props we wouldn't use in Atlassian product scenarios
/**
 * Use as a drop-in replacement for text fields in Atlassian products.
 *
 */
const AtlasTextfield = /*#__PURE__*/forwardRef(({
  ...props
}, forwardedRef) => {
  const {
    appearance = 'standard',
    isCompact = false,
    isDisabled = false,
    isInvalid = false,
    isRequired = false,
    isReadOnly = false,
    isMonospaced = false,
    width,
    elemAfterInput,
    elemBeforeInput,
    testId,
    onFocus,
    onBlur,
    onMouseDown,
    UNSAFE_className: unsafeClassName,
    ...delegated
  } = props;
  const innerRef = React__default.useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, innerRef);
  const handleOnFocus = event => onFocus && onFocus(event);
  const handleOnBlur = event => onBlur && onBlur(event);
  const handleOnMouseDown = React__default.useCallback(event => {
    // Running e.preventDefault() on the INPUT prevents double click behaviour
    // Sadly we needed this cast as the target type is being correctly set
    const target = event.target;
    if (target.tagName !== 'INPUT') {
      event.preventDefault();
    }

    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (innerRef && innerRef.current && !isDisabled && document.activeElement !== innerRef.current) {
      innerRef.current.focus();
    }
    return onMouseDown && onMouseDown(event);
  }, [onMouseDown, isDisabled]);
  return /*#__PURE__*/React__default.createElement(AtlasTextfieldWrapper, {
    "data-disabled": isDisabled || undefined,
    "data-invalid": isInvalid || undefined,
    "data-testid": testId && `${testId}-container`,
    "data-atlas-text-field--container": true,
    appearance: appearance,
    onMouseDown: handleOnMouseDown,
    className: unsafeClassName,
    width: width
  }, elemBeforeInput, /*#__PURE__*/React__default.createElement(StyledAtlasTextInput, _extends({}, delegated, {
    "data-compact": isCompact || undefined,
    "data-monospaced": isMonospaced || undefined,
    "data-testid": testId,
    "data-atlas-text-field--input": true,
    "aria-invalid": isInvalid || undefined,
    disabled: isDisabled,
    readOnly: isReadOnly,
    required: isRequired,
    onBlur: handleOnBlur,
    onFocus: handleOnFocus,
    ref: innerRef
  })), elemAfterInput);
});
AtlasTextfield.displayName = 'AtlasTextfield';
var AtlasTextfield$1 = AtlasTextfield;

export { AtlasTextfield$1 as default };
